export default __webpack_public_path__ + "static/media/6.4a0d4e41.png";